import { Youtube } from '@/components/Youtube';
import { LabradorComponent } from '@/types/component';

export const LabradorYoutube: LabradorComponent = ({ type, meta, data }) => {
  return <Youtube data-content-index={meta.contentIndex} vidID={data.vidID} />;
};
